// extracted by mini-css-extract-plugin
module.exports = {"masterVerifiedBtn":"IconLevel_masterVerifiedBtn__1CI2e","levelTwoBtn":"IconLevel_levelTwoBtn__3SulV","newSellerBtn":"IconLevel_newSellerBtn__1IH_a"};